import { render, staticRenderFns } from "./OnlineNum.vue?vue&type=template&id=37889bb0&scoped=true&"
import script from "./OnlineNum.vue?vue&type=script&lang=js&"
export * from "./OnlineNum.vue?vue&type=script&lang=js&"
import style0 from "./OnlineNum.vue?vue&type=style&index=0&id=37889bb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37889bb0",
  null
  
)

export default component.exports